module.exports = __webpack_public_path__ + "f7072957f90365992c13821425532634.pdf";